// extracted by mini-css-extract-plugin
export default {"partner-demo-logo":"PartnerDemoLogo_partner-demo-logo__FE+Sl"};